module.exports = __webpack_public_path__ + "assets/img/69_213_4.121cd67a.jpg";